import React from "react";
import "./SummaryCard.css";

function SummaryCard({ type, text, logo, link }) {
  let summaryCardClass = "";
  let summaryCardClassLogo = "";
  if (type === "employee") {
    summaryCardClass = "number-employees";
    summaryCardClassLogo = "fa-solid fa-users";
  } else if (type === "on-leave") {
    summaryCardClass = "leave-employees";
    summaryCardClassLogo = "fa-solid fa-plane-departure";
  } else if (type === "new-employee") {
    summaryCardClass = "new-employees";
    summaryCardClassLogo = "fa-solid fa-user-plus";
  } else if (type === "upcoming-holiday") {
    summaryCardClass = "upcoming-holiday";
    summaryCardClassLogo = "fa-regular fa-calendar-check";
  }
  return (
    <div className={`employee-summary-card ${summaryCardClass}`}>
      <div className='employee-summary-card-logo'>
        <i className={summaryCardClassLogo}></i>
      </div>
      <div className='employee-summary-card-info'>
        <div className='employee-summary-card-text'>
          <p>{text}</p>
          <p>450</p>
        </div>
        <div className='employee-summary-card-link'>
          <a href={link}>
            <i className='fa-solid fa-angle-right'></i>
          </a>
        </div>
      </div>
    </div>
  );
}

export default SummaryCard;
